import { DecorationSet } from 'prosemirror-view';
import { getPluginState } from '../pm-plugins/plugin-factory';
import { updateNodeDecorations } from './decoration';
export var updatePluginStateDecorations = function (state, decorations, key) {
    return updateNodeDecorations(state.doc, getPluginState(state).decorationSet || DecorationSet.empty, decorations, key);
};
//# sourceMappingURL=update-plugin-state-decorations.js.map